import { finish, error, clear } from '../../../modules/betslip/actions/accept-referred-betslip';
import { request as getFreebetCredits } from '../../../modules/customers/actions/get-freebet-credits';

import api from '../../../api';

export function request(dispatch, { userId, override }) {
    api.post('/customers/' + userId + '/requested-betslip/accept', { ignoreProblems: [] }).then(
        (data) => {
            dispatch(finish(userId, data));

            // TODO: The updated/refresh of freebet credits should be done in a way that it will be updated globally
            // TODO: when either placement/accept/offer-accepted completed successfully
            // TODO: Ideally it will be good to update it based on push notifications
            dispatch( getFreebetCredits( userId ) );

            setTimeout(() => {
                dispatch(clear(userId));
            }, 4000);
        },
        ({ errors }) => dispatch(error(userId, errors))
    );
}
